var map = {
	"./--info.jpg": "cIbx",
	"./-info.jpg": "oAth",
	"./AppPic.jpg": "E3Xf",
	"./Kwai.jpg": "1ZYQ",
	"./LiveBg01.png": "RK3m",
	"./TiktokPic.jpg": "Eqm/",
	"./aicaiTip01.png": "ZT45",
	"./aicaiTip02.png": "VdPI",
	"./app.png": "/5Ul",
	"./appEwmBg.png": "Riqy",
	"./appQR.png": "O+Am",
	"./avatar.png": "HfaK",
	"./banner.jpg": "hKcQ",
	"./banner01.png": "vh2T",
	"./becomeExpert.png": "U/kC",
	"./companyIcon.png": "RqWo",
	"./course01.jpg": "I4ny",
	"./course02.jpg": "/mIO",
	"./course03.jpg": "tzYh",
	"./course04.jpg": "NVFh",
	"./course05.jpg": "mapb",
	"./course06.jpg": "sW8E",
	"./course07.jpg": "Zk6m",
	"./course08.jpg": "1xSO",
	"./course09.jpg": "AEAZ",
	"./css/style.css": "VaBq",
	"./customerEwm.png": "nzA5",
	"./drawItemBg.png": "Fkgl",
	"./fcBg.png": "6yiM",
	"./fcBg01.png": "7tY5",
	"./fenxiNext.png": "9gfG",
	"./fenxiThis.png": "xmmz",
	"./flcp.png": "L9FH",
	"./footballIcon01.png": "MsaL",
	"./footballIcon02.png": "T+1f",
	"./footballIcon03.png": "zSqw",
	"./footballIcon04.png": "eSNL",
	"./footballIcon05.png": "F1kj",
	"./footballIcon06.png": "Kxip",
	"./footballIcon07.png": "uUhV",
	"./h5.png": "Un46",
	"./i48_15x5.png": "EfaO",
	"./i48_7lc.png": "s5RG",
	"./i48_df61.png": "v+kc",
	"./i48_fc3d.png": "s1cc",
	"./i48_pl3.png": "5GRh",
	"./i48_pl5.png": "YLk8",
	"./i48_qxc.png": "wuYT",
	"./i64_dlt.png": "NGw9",
	"./i64_ssq.png": "VcqA",
	"./iconLogo.png": "iYIv",
	"./img1.jpg": "Eaaq",
	"./img2.jpg": "aXrP",
	"./img3.jpg": "DjEO",
	"./img4.jpg": "wSF9",
	"./info.jpg": "SYTV",
	"./info_t.jpg": "pTmN",
	"./info_t1.jpg": "P3O0",
	"./liveBg02.png": "Dz9P",
	"./liveSBg01.png": "StOt",
	"./liveSBg02.png": "PdIt",
	"./logo.png": "7Otq",
	"./logo01.png": "ywVb",
	"./new_15x5.png": "vDw6",
	"./new_df61.png": "QXo0",
	"./new_dlt.png": "9FZW",
	"./new_fcsd.png": "mLfr",
	"./new_kl8.png": "vAPw",
	"./new_pl3.png": "9DH3",
	"./new_pl5.png": "eI+r",
	"./new_qlc.png": "K34+",
	"./new_qxc.png": "2yW0",
	"./new_ssq.png": "vx9z",
	"./officialPic.jpg": "CvS+",
	"./officialQR.png": "KAVW",
	"./polic.png": "dIZ0",
	"./spreadArt.png": "2CI5",
	"./tcBg.png": "gRox",
	"./tcBg01.png": "mi2e",
	"./trendChartNav01.png": "tj/K",
	"./trendChartNav02.png": "gHVE",
	"./tycp.png": "XYf+",
	"./type01.png": "/NxC",
	"./type02.png": "gMIv",
	"./type03.png": "s3ih",
	"./type04.png": "gAzt",
	"./window.png": "K1Pa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 101